const cosmos = {
  "cosmos-sdk/MsgSend": "/cosmos.bank.v1beta1.MsgSend",
  "cosmos-sdk/MsgDelegate": "/cosmos.staking.v1beta1.MsgDelegate",
  "cosmos-sdk/MsgUndelegate": "/cosmos.staking.v1beta1.MsgUndelegate",
  "cosmos-sdk/MsgBeginRedelegate": "/cosmos.staking.v1beta1.MsgBeginRedelegate",
  "cosmos-sdk/MsgWithdrawDelegationReward":
    "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
  "cosmos-sdk/MsgWithdrawDelegatorReward":
    "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
  "cosmos-sdk/MsgVote": "/cosmos.gov.v1beta1.MsgVote",
  "cosmos-sdk/MsgDeposit": "/cosmos.gov.v1beta1.MsgDeposit",
  "cosmos-sdk/MsgGrant": "/cosmos.authz.v1beta1.MsgGrant",
  "cosmos-sdk/MsgRevoke": "/cosmos.authz.v1beta1.MsgRevoke",
};

const osmosis = {
  "osmosis/gamm/swap-exact-amount-in":
    "/osmosis.gamm.v1beta1.MsgSwapExactAmountIn",
};

const terra = {
  "bank/MsgSend": "/cosmos.bank.v1beta1.MsgSend",
  "staking/MsgDelegate": "/cosmos.staking.v1beta1.MsgDelegate",
  "staking/MsgUndelegate": "/cosmos.staking.v1beta1.MsgUndelegate",
  "staking/MsgBeginRedelegate": "/cosmos.staking.v1beta1.MsgBeginRedelegate",
  "distribution/MsgWithdrawDelegationReward":
    "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
  "market/MsgSwap": "/terra.market.v1beta1.MsgSwap",
  "wasm/MsgExecuteContract": "/terra.wasm.v1beta1.MsgExecuteContract",
  "gov/MsgVote": "/cosmos.gov.v1beta1.MsgVote",
  "gov/MsgDeposit": "/cosmos.gov.v1beta1.MsgDeposit",
  "msgauth/MsgGrantAuthorization": "/cosmos.authz.v1beta1.MsgGrant",
  "msgauth/MsgRevokeAuthorization": "/cosmos.authz.v1beta1.MsgRevoke",
};

export default {
  ...cosmos,
  ...osmosis,
  ...terra,
};
